import { render } from "./ColorLegend.vue?vue&type=template&id=785b09ab"
const script = {}

import "./ColorLegend.vue?vue&type=style&index=0&id=785b09ab&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__